import { render } from "./connection-whatsapp.vue?vue&type=template&id=6a9c832c&scoped=true"
import script from "./connection-whatsapp.vue?vue&type=script&lang=js"
export * from "./connection-whatsapp.vue?vue&type=script&lang=js"

import "./connection-whatsapp.vue?vue&type=style&index=0&id=6a9c832c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9c832c"]])

export default __exports__